import { render, staticRenderFns } from "./ChooseRollOff.vue?vue&type=template&id=b5fe3736"
import script from "./ChooseRollOff.vue?vue&type=script&lang=js"
export * from "./ChooseRollOff.vue?vue&type=script&lang=js"
import style0 from "./ChooseRollOff.vue?vue&type=style&index=0&id=b5fe3736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports